import AdaptiveLogo from '../../../common/controls/AdaptiveLogo';
import { getCompanyImage, getUniversityImage } from '../../../common/styles/Images';
import { getDomainValueForCode, isEmpty, formatDesignationDisplay } from '../../../library/Core/SmartFunctions';
import { getFieldOfStudyName } from '../alumni-profile/service/student-profile-view.service';
import { jobPlace, pickDisplayJob } from '../../../library/Service/currentJobDisplay';

const CardWorking = ({ alumni, state }: { alumni: any;  state: any }) => {
    console.log(alumni, " alumni ")

    const getEducationDetails = (alumni: any) => {
        let title = '';
        let university_name = '';
        let IsPrestigiousCollege='';
        let department='';
        switch (alumni?.pursuingEducationLevelCode) {
            case 'UG':
                title = 'Pursuing UG';
                university_name=alumni.universityName
                IsPrestigiousCollege=alumni?.isPrestigiousCollege 
                department=getFieldOfStudyName(alumni.fieldOfStudyCode, state)
                break;

            case 'PG':
                title = 'Pursuing PG';
                university_name=alumni.pgUniversityName
                IsPrestigiousCollege=alumni?.pgIsPrestigiousCollege 
                department=getFieldOfStudyName(alumni.pgFieldOfStudyCode, state)
                break;

            case 'JOINED_UG':
                title = 'Joined UG';
                university_name=alumni.universityName
                IsPrestigiousCollege=alumni?.isPrestigiousCollege 
                department=getFieldOfStudyName(alumni.fieldOfStudyCode, state)
                break;

            case 'JOINED_PG':
                title = 'Joined PG';
                university_name=alumni.pgUniversityName
                IsPrestigiousCollege=alumni?.pgIsPrestigiousCollege 
                department=getFieldOfStudyName(alumni.pgFieldOfStudyCode, state)
                break;
            case 'Doctoral':
                title = 'Joined Doctoral';
                university_name=alumni.universityName
                IsPrestigiousCollege=alumni?.isPrestigiousCollege 
                department=getFieldOfStudyName(alumni.fieldOfStudyCode, state)
                break;
        }
        return (
             `<div class="alumni_univarsity_brife">
                    <div class="alumni_education text-start">${title}</div>
                    <div class="alumni_univarsity_name">
                        <span class="text-black">${university_name}</span>
                        ${IsPrestigiousCollege === '1' ? (
                            `<i class="ms-1 position-static bg-transparent">
                                <img src="https://miles.univariety.com/school/public/images/subtraction.svg" alt="" />
                            </i>`
                        ) : ''}
                    </div>
                    ${!isEmpty(department) ? (
                        `<div class="alumni_univarsity_subject">
                            <i></i><span class="text-start">${department}</span>
                        </div>`
                    ) : ''}
                </div>`
        );
    };

    const lookup = (id: any, domain: string) => getDomainValueForCode(id, domain, state);
    const { job: currentJob, count: currentRoleCount } = pickDisplayJob(
        alumni?.currentJobsJson,
        undefined,
        alumni?.workingStatusCode
    );
    const place = currentJob ? jobPlace(currentJob, lookup) : null;
    const credited = currentJob?.jobCategory === 'SELF_EMPLOYED_AND_FREELANCING';

    const logoSrc = place
        ? place.kind === 'institute'
            ? getUniversityImage(place.logo)
            : getCompanyImage(place.logo || '')
        : getCompanyImage('');

    const shownCompany = place?.name || '';
    const shownDesignation = currentJob?.designation;
    const shownPrestigious = place?.kind === 'company' && Number(currentJob?.isPrestigious) === 1;

    return (
        <div key={alumni.uuid} className="alumni_univarsity_details working">
            <div className="alumni_univarsity_details_inner_cover">
                <AdaptiveLogo
                    className="alumni_univarsity_logo"
                    src={logoSrc}
                    alt={credited ? 'Freelance Logo' : place?.kind === 'institute' ? 'Institute Logo' : 'Company Logo'}
                    fallbackShape="square"
                />
                <div className="alumni_univarsity_brife">
                    <div className="alumni_education">
                        <div className="row g-2">
                            <div className="col d-flex align-items-center flex-nowrap">
                                <span>{credited ? 'Credited as' : 'Working as'}</span>
                                {currentRoleCount > 1 && (
                                    <span className="current-roles-count">{currentRoleCount} current roles</span>
                                )}
                            </div>
                            {(alumni?.presentEducationStatusCode === 'PURSUING_STUDIES' && alumni?.isWorking === 1 &&
                                ((alumni?.pursuingEducationLevelCode === 'PG' && !isEmpty(alumni.pgUniversityName)) ||
                                (alumni?.pursuingEducationLevelCode === 'UG' && !isEmpty(alumni.universityName)))) &&
                                    <div className="col-auto">
                                        <a
                                            href="javascript:;"
                                            className="btn-white-tooltip"
                                            data-bs-toggle="tooltip"
                                            data-bs-html="true"
                                            title=""
                                            data-bs-original-title={getEducationDetails(alumni)}>
                                            Education Status
                                        </a>
                                    </div>
                                }
                        </div>
                    </div>
                    <div className="alumni_univarsity_name">
                        <span>{shownCompany}</span>
                        {shownPrestigious && (
                            <i className="ms-1 position-static bg-transparent">
                                <img src={`${process.env.REACT_APP_IMAGE_BASEPATH}/subtraction.svg`} />
                            </i>
                        )}
                    </div>
                    {shownDesignation && (
                        <div className="alumni_univarsity_subject">
                            <i className="icon-brifecase"></i>
                            <span>{formatDesignationDisplay(shownDesignation, state, { workingStatusCode: currentJob?.jobCategory })}</span>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default CardWorking;
